import { render } from "./MainHeader.vue?vue&type=template&id=b5705070&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=b5705070&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5705070"

export default script